// extracted by mini-css-extract-plugin
export default {"mobileThreshold":"1000px","flex-row-space-between":"flex-row-space-between","flex-column-space-between":"flex-column-space-between"};